import { useCallback, useState } from "react"
import { EditGroup } from "../../Components/EditGroup"
import { BlockField, BlockRow } from "../../Components/Block"
import { Menu } from "../../Components/Menu"
import { IShipUserLevel } from "../../Types"
import { ShipDataViewData } from "../ShipData/Context"
import { userEditableFields } from "./Data"
import { useShipUserEdit } from "./useShipUserEdit"
import { InviteUserOverlay } from "./InviteUserOverlay"
import { ShipUserEditViewProps } from "./Params"

// ---------------------------------------------------------------------------
// Personen without user account
// ---------------------------------------------------------------------------

export function ShipPersonEditView({ editable, shipUserCrewRoleOptions, shipUserLevelOptions, showLabels = false, user, ship }: ShipUserEditViewProps) {
  const { app, t, edited, name, shortname, onEdited, updateShipUser, updateShipUserActive } = useShipUserEdit({ user });
  const [showInviteOverlay, setShowInviteOverlay] = useState(false);

  const _handleInvite = useCallback(async () => {
    await updateShipUserActive(false);
    setShowInviteOverlay(false);
  }, [updateShipUserActive]);

  const isPrimarySelf = user.shipUserLevel === IShipUserLevel.primary && user.userId === app.user?.id;
  const menuItems = [
    ...(user.active > 0 && !user.userId ? [
      { id: "user_inactive", onClick: () => { updateShipUserActive(false); return true; }, title: t("user_inactive") },
    ] : []),
    ...(user.active < 1 ? [
      { id: "user_active", onClick: () => { updateShipUserActive(true); return true; }, title: t("user_active") },
    ] : []),
    // TODO: invite temporarily suppressed for release — re-enable the `user_invite`
    // menu item (and its leading MenuItemDividerProps divider) once inviting persons
    // is ready. The InviteUserOverlay plumbing below is intentionally kept for that.
  ];

  return (
    <EditGroup key={user.id} changed={edited} editableFields={userEditableFields} onSave={updateShipUser} className="editgroup_boxed">
      <BlockRow className="ShipUserEditView-row">
        <BlockField className="block_field_small_22_fix" label={showLabels ? t("user_name") : undefined}>
          <input name="name" value={name} onChange={onEdited} readOnly={!editable} className={user.active < 1 ? "user_deactivated" : ""} />
        </BlockField>
        <BlockField className="block_field_small_10" label={showLabels ? t("user_shortname") : undefined}>
          <input name="shortname" value={shortname} onChange={onEdited} readOnly={!editable} className={user.active < 1 ? "user_deactivated" : ""} />
        </BlockField>
        <BlockField className="block_field_small_10" label={showLabels ? t("user_crew_role") : undefined}>
          <select className={user.active < 1 ? "user_deactivated" : ""} defaultValue={user.shipUserCrewRole} name="shipUserCrewRole" onChange={onEdited} disabled={!editable}>
            {shipUserCrewRoleOptions}
            {ShipDataViewData.legacyCrewRoleOption(t, user.shipUserCrewRole)}
          </select>
        </BlockField>
        {!isPrimarySelf && menuItems.length > 0 && (
          <BlockField className="button_user_options user_options">
            <Menu button="..." buttonClass="button" global={true} items={menuItems} />
          </BlockField>
        )}
      </BlockRow>

      {showInviteOverlay && (
        <InviteUserOverlay
          ship={ship}
          user={user}
          editable={editable}
          shipUserCrewRoleOptions={shipUserCrewRoleOptions}
          shipUserLevelOptions={shipUserLevelOptions}
          onClose={() => setShowInviteOverlay(false)}
          t={t}
        />
      )}

    </EditGroup>
  );
}
